import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";

// import SPOrderDetails from "../../../../components/global/Sidepanels/SpOrderDetails/SpOrderDetails";
import { useTranslation } from 'react-i18next';
import TabView3 from "../../../../components/theme/TabView3/TabView3";
import InboundInboundLines from "./views/InboundLines";
import InboundsView from "./views/Inbounds";
import InboundReturns from "./views/Returns";
import CustomerInbounds from "./views/Customer";
import { warehouseInboundInboundsConfig } from "./warehouseInboundInboundsConfig";
import ShDoubleTextSkeleton from "../../../../components/theme/skeleton/ShDoubleTextSkeleton";
import Heading from "../../../../components/theme/text/Heading";
import { useSelector } from "react-redux";

import cx from 'classnames';
import Text from "../../../../components/theme/text/Text";
import { useEffect, useState } from "react";
import CallReceivedOutlinedIcon from '@mui/icons-material/CallReceivedOutlined';
import Subheading from "../../../../components/theme/text/Subheading";
import { useTopbar } from "../../../../contexts/TopbarProvider";
import InboundTotalsPanel from "../../../../components/global/dashboard/InboundTotalsPanel";


const Inbounds = () => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {showExtraTitle,clearExtraTitle } = useTopbar();
    
    // The totals panel belongs to the All tab, which reports whether it is the one open.
    const [allTabActive, setAllTabActive] = useState(false);

    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);
    const [config,setConfig] = useState(warehouseInboundInboundsConfig(isFulfilment));
    useEffect(() => {
        setConfig(warehouseInboundInboundsConfig(isFulfilment));
    },[isFulfilment])
    

    useEffect(() => {
        showExtraTitle(t("inbounds"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])

    return (
        <Box sx={{background:"", width:1,paddingTop:9}}>
            {ready ?
            <>
                {allTabActive && <InboundTotalsPanel />}

                <TabView3
                    tabConfig={config}
                    sx={{
                        background:"green",
                        minHeight: allTabActive ? "calc(100% - 431px)" : "calc(100%)",
                        background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        position:"relative",
                        zIndex:2,
                        display:"flex",
                        flexDirection:"column",

                        "&:before" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            left:0,
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            top:"40px",
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transition:"250ms"
                        },

                        "&:after" : {
                            content: "''",
                            display:"block",
                            width:"32px",
                            height:"32px",
                            position:"absolute",
                            top:0,
                            zIndex:1,
                            backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                            top:"40px",
                            right:0,
                            height:"48px",
                            width:"24px",
                            borderTopLeftRadius:"24px",
                            boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                            transform:"scaleX(-1)",
                            transition:"250ms"
                        },

                        "@media screen and (max-width: 47.9375em)" : {
                            "&:after, &:before" : {
                                top:"-0px"
                            }
                        }
                    }}
                >
                    <>
                        <InboundsView config={config.inbounds} onActiveChange={setAllTabActive}/>
                        <InboundInboundLines config={config.inboundLines}/>
                        {/* <InboundReturns config={config.returns} /> */}
                        {/* {isFulfilment && <CustomerInbounds config={config.customerInbounds}/>} */}
                    {/* <ActionReq */}
                    </>
                </TabView3>
                {/* </TabView> */}
            </>
            :null}
        </Box>
    );
};

export default Inbounds;